import AsyncSelect from "react-select/async";

const AsyncSelectField = ({
  label,
  name,
  value,
  compulsory = false,
  error,
  ...props
}) => {
  return (
    <div className={`formgroup mt-3`}>
      <label className="label" htmlFor={name}>
        {label}
      </label>
      <div className={`flex ${props.isDisabled ? "" : "pb-3"}`}>
        <AsyncSelect
          cacheOptions
          className={`myreact-select-2 container-select`}
          inputId={name}
          name={name}
          value={value}
          {...props}
        />
        {compulsory && <span className="label-imp-select-prd">*</span>}
      </div>
      {error && <p className="label-error">{error}</p>}
    </div>
  );
};

export default AsyncSelectField;
